import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MediaImageModel } from '@modules/media/models/media-image.model';
import { MediaVideoModel } from '@modules/media/models/media-video.model';

import { SectionType } from '../enums/section-type.enum';

@Component({
  selector: 'mb-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionComponent implements OnInit {
  @HostBinding('class.show')
  @Input()
  show = true;

  @Input() index!: number;
  @Input() data: any;

  @Output() openMedia = new EventEmitter<MediaImageModel | MediaVideoModel>();

  public teaserSectionType = SectionType;
  public sectionHeadlineClasses = ['header-inline'];

  constructor(private elRef: ElementRef) {}

  ngOnInit(): void {
    if (this.data?.type) {
      this.elRef.nativeElement.classList.add(`section-type-${this.data.type}`);
    }

    if (!this.data?.headline && this.data?.anchor) {
      this.sectionHeadlineClasses.push('header-without-headline');
    }
  }
}
